import React from "react";
import { Card, CardBody, Col, Row } from "reactstrap";
import { useGebruikerContext } from "../../Context/GebruikerContext";

const LaatsteLogin = () => {
	const { userDetails } = useGebruikerContext();
	const data = userDetails?.profileList;
  
	return (
		<>
			<Card className="main-card">
				<CardBody>
					<Row>
						<Col className=" col-12">
							<h5 className="mb-4">Laatste login</h5>
							<Row className="mb-4 mt-1 d-flex justify-content-between align-items-center">
								<Col className="col-md-6 mt-0">Website</Col>
								<Col className="col-md-6 mt-0">{data?.iLastWebLogin}</Col>
							</Row>
							<Row className="mb-4 mt-1 d-flex justify-content-between align-items-center">
								<Col className="col-md-6 mt-0">App</Col>
								<Col className="col-md-6 mt-0">{data?.iLastAppLogin}</Col>
							</Row>
						</Col>
					</Row>
				</CardBody>
			</Card>
		</>
	);
};

export default LaatsteLogin;
